import React, { FC } from 'react';
import bytes from 'bytes';

import { Stack } from '../Stack';
import { Download24, File24 } from '../../icons';
import { Avatar } from '../Avatar';
import { Typography } from '../Typography';
import { IconButton } from '../IconButton';


export interface DownloadFileProps {
    name: string;
    size: number;
    ext?: string;
    type?: 'default' | 'download';
    invactive?: boolean;
    withDownloadButton?: boolean;
    onDownload?: () => void;
}

export const DownloadFile: FC<DownloadFileProps> = ({
    name, ext, size, invactive, type = 'default', withDownloadButton, onDownload,
}) => (
    <Stack
        direction='row'
        spacing={4}
        alignItems='center'
        width='231px'
        onClick={onDownload}
        title={name}
        data-testid='document-container'
        sx={{
            cursor: onDownload ? 'pointer' : 'default',
        }}
    >
        <Avatar
            size='M'
            {...type === 'default' && {
                bgColor: 'grayscale.shade10',
                color: invactive ? 'grayscale.shade85' : 'infoCustom.green50',
            }}
        >
            {type === 'default' ? <File24 /> : <Download24 />}
        </Avatar>
        <Stack spacing={1} flexGrow={1} overflow='hidden'>
            <Typography
                variant='regularBody2'
                color='grayscale.shade100'
                noWrap
                data-testid={`document-${name}`}
            >
                {name}
            </Typography>
            <Typography variant='regularCaption1' color='grayscale.shade85'>
                {`${ext ? `${ext.toUpperCase()}・` : ''}${bytes(size, { unitSeparator: ' ' })}`}
            </Typography>
        </Stack>
        {withDownloadButton && (
            <IconButton variant='stroke' size='small'>
                <Download24 />
            </IconButton>
        )}
    </Stack>
);
